import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { IFarmModel } from 'src/app/core/models/interfaces/farm-model';
import { ISprayingHour } from 'src/app/core/models/interfaces/spraying-hours';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'orbit-spraying-hours',
  templateUrl: './spraying-hours.component.html',
  styleUrls: ['./spraying-hours.component.scss'],
})
export class SprayingHoursComponent extends BaseModal implements OnInit {

  @Input() farm: IFarmModel
  selectedDay: "today" | "tomorrow" = "today"
  todaySpraying: Array<ISprayingHour>
  tomorrowSpraying: Array<ISprayingHour>
  loading: boolean = false;
  constructor(private modalService: ModalService, private farmService: FarmApiService, private loadingService: LoadingService) {
    super()
    super._modalService = modalService;
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSprayingHours()
  }


  close() {
    this.dismiss(null);
  }

  initSprayingHours() {
    this.loading = true;
    let geoJson = JSON.parse(this.farm.GeoJson)
    let center = {
      lat: geoJson.geometry.coordinates[0][0][1],
      lng: geoJson.geometry.coordinates[0][0][0]
    }
    this.loadingService.showLoading();
    this.farmService.GetSprayingHours(center).subscribe(response => {
      this.loadingService.hideLoading();
      if (response.IsSuccess) {
        this.todaySpraying = response.Data.SprayingData[0].Data
        this.tomorrowSpraying = response.Data.SprayingData[1].Data
      }
      this.loading = false
    }, err => {
      this.loading = false
    })
  }

  segmentChanged(ev) {
    this.selectedDay = ev.detail.value
  }

}
